import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Live tenant/role-scoped customer requests (territory-scoped for agents/managers).
export function subscribeRequests({ tenantId, role, territoryIds = [] }, onChange, onError) {
  if (!tenantId) {
    onChange([]);
    return () => {};
  }
  // Territory-scoped roles with no territories read nothing — never issue an
  // unscoped query (mirrors subscribeLeads; avoids a doc-by-doc "list" deny).
  if ((role === 'agent' || role === 'manager') && (territoryIds?.length ?? 0) === 0) {
    onChange([]);
    return () => {};
  }
  const constraints = [where('tenantId', '==', tenantId)];
  if (role === 'agent' || role === 'manager') {
    constraints.push(where('territoryId', 'in', territoryIds.slice(0, 30)));
  }
  const q = query(collection(db, 'requests'), ...constraints);
  return onSnapshot(
    q,
    (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => (onError ? onError(err) : console.error('requests listener error', err)),
  );
}
